import React from 'react';

type CardImageProps = {
    url?: string;
    hasMedia?: boolean;
    option?: string;
    size?: string;
    className?: string;
    width?: string | number;
    height?: string | number;
    deleteMedia?: () => void;
} & React.HTMLAttributes<HTMLDivElement>;

const CardImage: React.FC<CardImageProps> = ({
    url,
    hasMedia,
    option = 'top',
    size,
    className = '',
    width,
    height,
    deleteMedia,
    ...otherProps
}) => {
    const baseClass = 'gds-card__img-container';
    const optionClass = option ? `${baseClass}--${option}` : '';
    const sizeClass = size ? `${baseClass}--${size}` : '';
    const classNames = `${baseClass} ${optionClass} ${sizeClass} ${className}`;

    return (
        <div className={classNames} {...otherProps}>
            {hasMedia ? (
                <>
                    <img
                        className="gds-card__img"
                        src={url}
                        width={width}
                        height={height}
                        alt="Media"
                    />
                    {deleteMedia && (
                        <button
                            type="button"
                            className="gds-circular-button -m-r-1 gds-circular-button--xs gds-circular-button--danger -m-a-1"
                            style={{
                                position: 'absolute',
                                bottom: '0',
                                right: '0',
                            }}
                            onClick={deleteMedia}
                        >
                            <i className="fa fa-fw fa-trash-alt" />
                        </button>
                    )}
                </>
            ) : (
                <div
                    className="gds-card__img gds-flex -text-center gds-flex--justify-center gds-flex--direction-col"
                    style={{
                        width,
                        height,
                        alignItems: 'center',
                        alignContent: 'center',
                        minHeight: '150px',
                    }}
                >
                    <i className="fal fa-images" />
                    <p>No media available</p>
                </div>
            )}
            <div className="gds-card__img-helper" />
        </div>
    );
};

export default CardImage;
